import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../services/firebase";
import generateCustomID from "../../utils/generateCustomID";

const checkCustomerBlock = async (blockHouse) => {
  if (!blockHouse) return false;

  const customerId = generateCustomID(blockHouse.toUpperCase());
  const customerDocRef = doc(firestore, "customer", customerId);
  const customerDoc = await getDoc(customerDocRef);

  if (customerDoc.exists()) {
    const customerData = customerDoc.data();
    const isBlocked = customerData.isBlocked ? customerData.isBlocked : null;

    if (isBlocked) {
      return isBlocked;
    }
  }
  return false;
};

export default checkCustomerBlock;
